export enum TeamRoleFilterEnum {
    TeamLeader = 'teamLeader',
    TeamMember = 'teamMember',
    TrainingResponsible = 'trainingResponsible',
    TeamWatcher = 'teamWatcher',
}
